import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  value: number;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.value = undefined;
  }
}

export const gqlGetQuery = gql`
  query getNomoi($limit: Int, $offset: Int, $order: String, $where: String) {
    getNomoi(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getNomosById($id: Int) {
    getNomosById(id: $id) {
      id
      name
    }
  }
`;

export const gqlAdd = gql`
  mutation addRegionType($data: RegionInput) {
    addRegion(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateRegion($data: RegionInput) {
    updateRegion(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteRegion($id: Int) {
    deleteRegion(id: $id)
  }
`;
